var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportAnswers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37431 1.89552V3.38518H1.90632V13.0679H12.3316V8.59896H13.821V14.5576H0.416992V1.89552H6.37431ZM11.3689 0.624023L14.8741 4.13L11.3689 7.63598L10.3157 6.58264L12.0228 4.87481L10.0976 4.87483C8.9079 4.87483 7.93538 5.80506 7.86743 6.97801L7.86364 7.10931V10.8334H6.37431V7.10931C6.37431 5.10665 7.95472 3.4732 9.93613 3.38862L10.0976 3.38518L12.0227 3.38514L10.3157 1.67737L11.3689 0.624023Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportAnswers);
export default __webpack_public_path__ + "static/media/export-answers.1bb6ba7274d27bce4985679477c0e28d.svg";
export { ForwardRef as ReactComponent };